export default {
	methods: {
		getAnalyticsData() {
			const clientID =				typeof yaCounter994527 !== 'undefined'
				? yaCounter994527.getClientID()
				: '';
			const { UAClientID } = window;
			const BpmRef = this.$cookies.get('bpmRef') || '';
			const BpmHref = this.$cookies.get('bpmHref') || '';
			const roistatVisitId = this.$cookies.get('roistat_visit') || '';
			return {
				SkGAClientId:
					typeof UAClientID !== 'undefined' ? UAClientID : '',
				SkYMClientId:
					typeof clientID !== 'undefined' ? clientID : '',
				roistatVisitId:
					typeof roistatVisitId !== 'undefined' ? roistatVisitId : '',
				BpmHref,
				BpmRef,
			};
		},
	},
};
